<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="计费规则选择"
  >
    <div class="dialog-content">
      <sirui-search
        ref="AdjustmentCostsDialog"
        :query="query"
        :isQueryPanel="false"
        :columns="searchFormColumns"
        :rules="tableRules"
        @changeMethod="changeMethod"
      ></sirui-search>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="chooseAdjustmentHandlerg"
          >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, tableRules } from './index.js';
  // , tableList

  export default {
    props: {},
    data() {
      return {
        load: false,

        query: {
          adjustStatementQuantity: '',
          adjustOriginalPrice: '',
          adjustOriginalAmount: '',
          adjustReason: '',
        },
        tableRules,
        visible: false,
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns();
      },
    },
    watch: {
      'query.adjustStatementQuantity': {
        deep: true,
        handler: function (newV) {
          console.log('watch中：', newV);
          this.query.adjustOriginalAmount = (newV * this.query.adjustOriginalPrice).toFixed(2);
        },
      },
      'query.adjustOriginalPrice': {
        deep: true,
        handler: function (newV) {
          console.log('watch中：', newV);
          this.query.adjustOriginalAmount = (newV * this.query.adjustStatementQuantity).toFixed(2);
        },
      },
    },
    mounted() {},
    methods: {
      openDialog() {
        this.visible = true;
      },
      changeMethod() {},
      //确认关联
      chooseAdjustmentHandlerg() {
        this.$refs.AdjustmentCostsDialog.validate(async (valid, baseInfoData) => {
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }

          console.log(baseInfoData, 'baseInfoData');

          this.$emit('chooseAdjustmentHandlerg', baseInfoData);
          this.visible = false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
    // .el-form-item__label {
    //   width: 150px !important;
    // }
    // .el-form-item__content {
    //   margin-left: 150px !important;
    // }
  }
</style>
